import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { useLenis, useScrollOnMount, scrollToTop } from "./lib/navigation";
import { LeadModalProvider } from "./components/ConversionContactModal";
import { DiagnosticaProvider } from "./components/DiagnosticaModal";
import { trackPageView } from "./lib/tracking";
import NavigationHeader from "./components/NavigationHeader";
import Footer from "./components/Footer";
import FloatingConcierge from "./components/FloatingConcierge";
import BackToTop from "./components/BackToTop";
import Home from "./pages/Home";
import ProtocolPage from "./pages/ProtocolPage";
import AdminPage from "./pages/AdminPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#050505", color: "#f5f2ea", padding: 40, textAlign: "center" }}>
          <div>
            <p style={{ color: "#c9a45c", letterSpacing: "0.25em", fontSize: 11, fontWeight: 700 }}>A.C. HUB</p>
            <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 32, marginTop: 16 }}>Qualcosa è andato storto.</h1>
            <button onClick={() => window.location.reload()} className="btn btn-gold" style={{ marginTop: 24 }}>
              Ricarica la pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname.startsWith("/admin")) trackPageView(pathname);
  }, [pathname]);
  return null;
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop();
  }, [pathname]);
  useScrollOnMount();
  return null;
}

function SiteChrome() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) return null;
  return (
    <>
      <NavigationHeader />
      <FloatingConcierge />
      <BackToTop />
    </>
  );
}

function SiteFooter() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <Footer />;
}

function App() {
  useLenis();
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollManager />
        <PageTracker />
        <LeadModalProvider>
          <DiagnosticaProvider>
          <SiteChrome />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/protocollo/:slug" element={<ProtocolPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <SiteFooter />
          <Toaster position="bottom-left" theme="dark" toastOptions={{
            style: { background: "#141414", border: "1px solid rgba(201,164,92,0.35)", color: "#f5f2ea" },
          }} />
          </DiagnosticaProvider>
        </LeadModalProvider>
      </BrowserRouter>
      <div className="grain-overlay" aria-hidden="true" />
    </ErrorBoundary>
  );
}

export default App;
